import React, { useEffect, useState, useRef } from 'react'
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const BetRecords = () => {
    const { fetchData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [records, setRecords] = useState([])

    const [todayDepo, setTodayDepo] = useState({
        bet: 0,
        returns: 0
    })

    const [yestedayDepo, setYesterdayDepo] = useState({
        bet: 0,
        returns: 0
    })

    const [totalDepo, setTotalDepo] = useState({
        bet: 0,
        returns: 0
    })

    const navigate = useNavigate();

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/bet/records');
            setLoader(false);

            setRecords(data.records);

            setTodayDepo(data.todayPayout);
            setYesterdayDepo(data.yesterdayPayout);
            setTotalDepo(data.totalPayout)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <div className='dashboard'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Bet Records</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="summary-container">
                <div className="card">
                    <h2>Total Bet's</h2>
                    <p className="amount">${totalDepo.bet}<span> USD</span></p>
                    <p>winnings: ${totalDepo.returns} USD</p>
                </div>
                <div className="card">
                    <h2>Today's Bet</h2>
                    <p className="amount">${todayDepo.bet}<span> USD</span></p>
                    <p>winnings: ${todayDepo.returns} USD</p>
                </div>
                <div className="card">
                    <h2>Yesterday's Bet</h2>
                    <p className="amount">${yestedayDepo.bet}<span> USD</span></p>
                    <p>winnings: ${yestedayDepo.returns} USD</p>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Teams</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Result</th>
                            <th>Profit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.betId}</div>
                                    <div className="subtext">{w.date}</div>
                                </td>
                                <td>
                                    <div>{w.home.name} vs {w.away.name}</div>
                                    <div className="subtext">Account Id: {w.id}</div>
                                </td>
                                <td>
                                    <div>${w.amount}</div>
                                    <div className="subtext">In USD: {w.amount}$</div>
                                </td>
                                <td>
                                    <div>{w.status}</div>
                                </td>
                                <td>
                                    <div>{w?.result}</div>
                                </td>
                                <td>
                                    <div>{w.status === 'Finished' ? w?.result === 'Won' ? '+' : '-' : ''}${w?.profit}</div>
                                    <div className="subtext">Odd: {w.odd}</div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default BetRecords